<template>
  <v-flex>
    <v-menu
      v-if="schema.menu === true"
      ref="menu"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="time"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="time"
          :label="schema.label_menu"
          prepend-icon="access_time"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu2"
        v-model="time"
        :value="value"
        full-width
        @click:minute="
          $refs.menu.save(time)
          $emit('input', value)
        "
      ></v-time-picker>
    </v-menu>
    <v-spacer></v-spacer>
    <v-dialog
      v-if="schema.dialog === true"
      ref="dialog"
      v-model="modal2"
      :return-value.sync="time"
      persistent
      lazy
      full-width
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="time"
          :label="schema.label_dialog"
          prepend-icon="access_time"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker v-if="modal2" v-model="time" full-width>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="modal2 = false">Anulează</v-btn>
        <v-btn
          flat
          color="primary"
          @click="
            $refs.dialog.save(time)
            $emit('inputChange', time)
          "
          >OK</v-btn
        >
      </v-time-picker>
    </v-dialog>
  </v-flex>
</template>
<script>
export default {
  name: 'TimePicker',
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      time: this.initialValue,
      menu2: false,
      modal2: false
    }
  }
}
</script>
